module.exports = __webpack_public_path__ + "static/media/universal-app-montage.296876ea.jp2";